import { useQuery } from '@tanstack/react-query'
import { useApi } from '../api/contexto'
import type { ErrorApi } from '../api/errores'

export interface CargaDia {
  ruta: 'r1' | 'r2' | 'r3' | 'r4' | 'r5'
  dia: string
  carga: number
}

/** Métricas del panel de Logística (GET /api/clientes/resumen-logistica). */
export interface ResumenLogistica {
  // Carga operativa
  repartosSemana: number
  cargaPorDia: CargaDia[]
  diaMasCargado: { dia: string; carga: number } | null
  // Calidad de datos
  activos: number
  geocodificados: number
  porcentajeGeocodificados: number
  sinTelefono: number
  sinRuta: number
  // Seguimiento comercial
  enRiesgoFuga: number
  mediaSemanasSinPedir: number
}

/**
 * Resumen de métricas de Logística. Se refresca cada 2 min (los datos cambian
 * poco dentro de una jornada) y no reintenta en bucle si el backend tropieza.
 */
export function useResumenLogistica() {
  const api = useApi()
  return useQuery<ResumenLogistica, ErrorApi>({
    queryKey: ['resumen-logistica'],
    queryFn: ({ signal }) => api.pedir('/api/clientes/resumen-logistica', { senal: signal }),
    staleTime: 120_000,
    retry: 1,
  })
}
